import { c as _c } from "react/compiler-runtime";
import { Tab } from '@headlessui/react';
import React from 'react';
import { twMerge } from 'tailwind-merge';
interface PageTabProps extends Record<string, unknown> {
  children: React.ReactNode;
  className?: string;
}
export const PageTab = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = t2 => {
      const {
        selected
      } = t2;
      return twMerge("main-transition-colors w-fit px-4 pb-6 pt-6 outline-hidden sm:px-5", selected ? "text-text-primary border-b-brand-primary border-b-2" : "border-b-2 border-b-transparent", className);
    };
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <span className="font-inter whitespace-nowrap font-bold sm:text-[17px]">{children}</span>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <Tab className={t1} {...props}>{t2}</Tab>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};